/* ============================================================================
   Tokens EDI — la CHARTE (teal, ink, paper/canvas, accents, sidebar, fonts, OMBRES) est ÉMISE par
   <ThemeVars/> (ui-web, contrat de thème) : l'EDI en était déjà conforme verbatim, il la CONSOMME
   désormais au lieu de la recopier. Ne restent ici que ses EXTRAS d'app (héros, densité) + reset.
   Thème persisté via useWebTheme (clé oz-edi-theme).

   ⚠️ 🔴 LES OMBRES ONT QUITTÉ CE FICHIER, et c'était le dernier endroit où l'EDI ÉCRASAIT la charte.
   Il déclarait `--sh-sm` et `--sh-lg` en `rgba()` FIGÉES — donc `theme-web.ts` émettait bien ses
   ombres dérivées de l'encre du mode (`color-mix`), et l'EDI les remplaçait. `shadow.ts` le dit
   d'ailleurs en propres termes : « aucun thème n'émettait `--sh-sm` : partout sauf l'EDI, qui le
   déclare chez lui » — une note écrite quand la charte ne les portait pas encore, restée vraie dans
   le code bien après avoir cessé d'être nécessaire.
   ⚠️ `--sh-lg` N'EXISTE PAS À LA CHARTE : ses deux usages passent sur les jetons partagés — `--sh-modal`
   pour la modale, `--sh-popover` pour l'infobulle de supervision. ⚠️ LE RÔLE, JAMAIS LE CALIBRE : la
   charte nomme ses ombres par ce que la chose EST (popover / lifted / modal), et une infobulle n'est
   pas une modale ; les remplacer mécaniquement par la même aurait aligné la valeur en perdant le sens.
   Garder un jeton d'app qui double un jeton partagé, c'est se condamner à les voir diverger.
   ============================================================================ */
:root {
  --row-h:34px;
  --hero-bg:#ffffff;--hero-fg:#0c0e10;--hero-dim:#6c747c;--hero-line:#e2e6ea;--hero-bar:#2b3034;--hero-bar2:var(--teal-500);--hero-tint:radial-gradient(120% 150% at 92% -20%, #e6fbf4 0%, rgba(230,251,244,0) 62%);
}
[data-theme="dark"] {
  --hero-bg:#15181b;--hero-fg:#f3f5f7;--hero-dim:#8f98a1;--hero-line:#262b30;--hero-bar:#c4ccd2;--hero-bar2:var(--teal-500);--hero-tint:radial-gradient(120% 150% at 92% -20%, rgba(43,201,163,.14) 0%, rgba(43,201,163,0) 62%);
}
[data-density="compact"]{--row-h:30px}
[data-density="comfortable"]{--row-h:42px}

/* ⚠️ LE RESET VIT SOUS LA CHARTE (2026-09-08) — même correction que la Console et le store le
   2026-08-13, que l'EDI n'avait jamais reçue. Une déclaration NON CALQUÉE l'emporte sur n'importe
   quelle couche quelle que soit sa spécificité : `a{color:var(--teal-700)}` battait donc `.nav`,
   `.chip.active`, `.seg.active` et `.btn-link` de la charte. Mesuré au navigateur : l'item de rail
   COURANT sortait à un contraste de 1,00 — le libellé exactement de la couleur de son propre aplat,
   c'est-à-dire un menu dont la ligne où l'on se trouve est INVISIBLE. L'ordre est déclaré, pas subi :
   reset < charte < règles de l'app. Garde : `scripts/audit-cascade-charte.mjs`. */
@layer oz-reset, orgazone-charte;
@layer oz-reset {
  *{box-sizing:border-box}
  html,body,#root{margin:0;padding:0;height:100%}
  body{font-family:var(--font-sans);font-size:var(--t-control);color:var(--ink-900);background:var(--canvas);-webkit-font-smoothing:antialiased;font-feature-settings:'cv11','ss01';text-wrap:pretty}
  button{font-family:inherit;font-size:inherit;cursor:pointer;color:inherit}
  input,select,textarea{font-family:inherit;font-size:inherit}
  a{color:var(--teal-700);text-decoration:none}
  a:hover{color:var(--teal-600);text-decoration:underline}
  table{border-collapse:collapse}
}
/* ⚠️ LA RECETTE D'ASCENSEUR A QUITTÉ CE FICHIER (2026-09-04) : elle vit dans la charte
   (`ui-tokens/theme-web`), qui n'en avait aucune — le back-office et la Console gardaient donc la
   barre grise du système. C'est l'EDI qui avait raison ; c'est la charte qui lui manquait. */
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.35}}
@keyframes slidein{from{transform:translateX(16px);opacity:0}to{transform:translateX(0);opacity:1}}
